import React from 'react';
import { Button, Card, Col, Collapse, Input, message, Modal, Row } from 'antd';
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';


import BannerTemplate from './banner-template';
import InputField from './input';
import menu from '../icons/menu.png';
import { setTimeout } from 'timers';

const DragHandle = SortableHandle(() => <span ><img alt="drag handle" className="drag-handle" src={menu} /></span>);

const SortableItem = SortableElement(({item, index, key, handleChange} ) => {
    
        // console.log(item)
        return(

                <Card 
                title={
                    <div>
                        <DragHandle /> 
                        {item.position+1}
                    </div>
                }
                className="input-card"
                > 
                    <InputField 
                        index={item.position} 
                        item={item} 
                        handleChange={handleChange}
                        />
                </Card> 
    
        )

});

const SortableList = SortableContainer(({
    activeCategory,
    handleChange 
    }) => {
        const {items} = activeCategory;
        return (
            <ul className="items-list">
                <Collapse defaultActiveKey={["1"]} onChange={this.callBack}>
                    {items.map((item, index) => {
                        console.log(index)
                        return (
                            <SortableItem key={index} 
                            index={index} 
                            item={item} 
                            handleChange={handleChange} />
                        )
                    })}
                </Collapse>
            
            </ul>
        )
    }
);

class FeaturedModal extends React.Component {

    render() {

        const { activeCategory } = this.state;
        const { loading } = this.state;

        if(!this.props.activeCategory) {
            console.log(this.props)
            return <div>
                loading..
            </div>
        }

        return(
            <Modal
                className="edit-modal"
                visible={this.props.visible}
                onCancel={this.handleCancel}
                footer={[
                    <Button 
                        key="cancel" 
                        onClick={this.handleCancel}>
                            
                        Return

                    </Button>,

                    <Button 
                        key="save" 
                        type="primary" 
                        loading={loading} 
                        onClick={this.onOk}>
                      Save
                    </Button>,

                  ]}>
                <Row>
                    <BannerTemplate />   
                </Row>

                <Row className="input-category-title">
                    <Col span={5} >
                        Category Title:
                    </Col>

                    <Col span={19}> 
                        <Input 
                            id="title" 
                            size="small"
                            onChange={(e) => this.handleCategoryTitleChange(e)}
                            value={activeCategory.title}
                        />
                    </Col>
                </Row>

                <Row>
                    {console.log(this.state.activeCategory)}
                    <SortableList 
                        activeCategory={activeCategory} 
                        onSortEnd={this.onSortEnd} 
                        handleChange={this.handleChange}
                        useDragHandle={true}
                        />
                </Row>
                
            </Modal>
        )
    }

    constructor(props) {
        super(props);
        this.state = {
            activeCategory: props.activeCategory,
            activePosition: false,
            loading: false,
        }
    }

    componentWillMount() {
        const { activeCategory, activePosition} = this.props;
        console.log(this.props)
        this.setState({
            activeCategory,
            activePosition
        })
        setTimeout(() => {
            console.log(this.state)
        },100)
    }

    callback = (key) => {
        console.log(key)
    }

    handleCancel = () => {
        this.props.toggleVisibility()
    } 

    handleCategoryTitleChange = (e) => {
        const title = e.target.value;
        this.setState({
            activeCategory: {
                ...this.state.activeCategory,
                title
            }
        })
    }

    handleChange = (value, name, index) => {
        // console.log(value, name, index)
        this.setState({
            activeCategory: {
                ...this.state.activeCategory,
                items: [
                    ...this.state.activeCategory.items.map(
                        (item, i) => {
                            if(i === index) {
                                if(name==="title") {
                                    return {
                                        ...item,
                                        title:value
                                    }
                                } else if(name === "src") {
                                    return {
                                        ...item,
                                        src: value
                                    }
                                } else if(name === "link") {
                                    return {
                                        ...item,
                                        link: value
                                    }
                                }
                            } else return {
                                ...item
                            }

                            return item;
                        }
                    )
                ]
            }
        })
    }

    move(array, from, to) {
    
        array.splice(to, 0, array.splice(from, 1)[0]);

        array.map(
            (elem, i) =>  {
                elem.position = i 
                return elem;
            }
        );

        return array;
    };

    onOk = () => {
        const { activeCategory } = this.state;
        // console.log(activeCategory)
        this.setState({
            loading: true
        })

        let validated = true;
        const { items } = activeCategory;
        
        for( let i = 0; i<items.length; i++) {
            if(!items[i].title || !items[i].src || !items[i].link) {
                validated = false;
                break;
            }
        }

        if(!activeCategory.title) {
            validated = false;
        }

        // console.log(validated)
        if(validated) {
            setTimeout(() => {
                this.setState({
                    loading: false,
                })
                this.props.toggleVisibility();
                this.updateActiveCategory()
                // this.props.
                
            },200)
        } else {
            this.setState({
                loading: false,
            })
            message.error("All fields must be filled")
        }
        
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        // console.log(this.state)
        // console.log(oldIndex, newIndex)

        const itemArr = this.state.activeCategory.items
        this.move(itemArr, oldIndex, newIndex);
        // console.log(itemArr)


        this.setState({
            activeCategory: {
                ...this.state.activeCategory,
                items: itemArr
            }
        })
      };

      updateActiveCategory = () => {
        //   if(this.props.isNewCategory) {

        //   console.log(this.state.activeCategory)
          this.props.updateActiveCategory(this.state.activeCategory)
      }
}

export default FeaturedModal;


// WEBPACK FOOTER //
// ./src/components/featured/modal/index.js